import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';
import useScrollAnimation from '../hooks/useScrollAnimation';
import '../styles/scrollAnimations.css';
import './HeaderVideo.css';

const HeaderVideo = () => {
    const { language } = useLanguage();
    const t = translations[language].headerVideo;
    const [titleRef, titleVisible] = useScrollAnimation({ threshold: 0.2 });
    const [descriptionRef, descriptionVisible] = useScrollAnimation({ threshold: 0.2 });
    const [videoRef, videoVisible] = useScrollAnimation({ threshold: 0.2 });

    return (
        <div className="video-wrapper-2">
            <h2 
                ref={titleRef}
                className={`scroll-fade-in ${titleVisible ? 'is-visible' : ''}`}
            >
                {t.title}
            </h2>
            <p 
                ref={descriptionRef}
                className={`scroll-fade-in scroll-animation-delay-1 ${descriptionVisible ? 'is-visible' : ''}`}
            >
                {t.description}
            </p>
            <div 
                ref={videoRef}
                className={`video-container-2 scroll-fade-in-scale scroll-animation-delay-2 ${videoVisible ? 'is-visible' : ''}`}
            >
                <iframe
                    className="header-video-iframe"
                    src="https://www.youtube.com/embed/g4GuXZfzWho"
                    title="Company Vision Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                ></iframe>
            </div>
        </div>
    );
};

export default HeaderVideo;
